import React, { useState, useEffect } from "react";

const CONFETTI_ITEMS = [
  { left: "8%", delay: "0.2s", duration: "2.4s", color: "bg-yellow-400", shape: "rounded-full", size: "w-1.5 h-1.5" },
  { left: "18%", delay: "1.1s", duration: "3.2s", color: "bg-pink-500", shape: "rounded-sm", size: "w-2 h-1" },
  { left: "28%", delay: "0.5s", duration: "2.8s", color: "bg-blue-400", shape: "rounded-full", size: "w-1 h-2" },
  { left: "38%", delay: "2.3s", duration: "3.0s", color: "bg-emerald-400", shape: "rounded-sm", size: "w-1.5 h-1.5" },
  { left: "48%", delay: "1.5s", duration: "2.6s", color: "bg-purple-400", shape: "rounded-full", size: "w-2 h-2" },
  { left: "58%", delay: "0.7s", duration: "3.5s", color: "bg-rose-400", shape: "rounded-sm", size: "w-1 h-1" },
  { left: "68%", delay: "2.0s", duration: "2.9s", color: "bg-amber-400", shape: "rounded-full", size: "w-2 h-1" },
  { left: "78%", delay: "1.2s", duration: "3.1s", color: "bg-cyan-400", shape: "rounded-sm", size: "w-1.5 h-1.5" },
  { left: "88%", delay: "0.4s", duration: "2.7s", color: "bg-violet-400", shape: "rounded-full", size: "w-1 h-2" },
  { left: "95%", delay: "1.8s", duration: "3.3s", color: "bg-fuchsia-400", shape: "rounded-sm", size: "w-2 h-2" },
];

const PromoBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Hard cutoff: Do not show after June 17, 2026 (i.e. starting June 18, 2026 local time)
    const cutoffDate = new Date("2026-06-18T00:00:00").getTime();
    const now = Date.now();
    if (now >= cutoffDate) {
      return;
    }

    const dismissed = localStorage.getItem("promo_banner_dismissed");
    if (dismissed === "true") {
      return;
    }

    const firstSeen = localStorage.getItem("promo_banner_first_seen");
    const tenDaysMs = 10 * 24 * 60 * 60 * 1000;

    if (!firstSeen) {
      localStorage.setItem("promo_banner_first_seen", now.toString());
      setIsVisible(true);
    } else {
      const firstSeenTime = parseInt(firstSeen, 10);
      if (isNaN(firstSeenTime) || now - firstSeenTime > tenDaysMs) {
        // Expired or invalid timestamp
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem("promo_banner_dismissed", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="relative bg-slate-950 text-white text-center py-2.5 px-8 text-sm font-semibold tracking-wide flex items-center justify-center min-h-[40px] z-50 shadow-md overflow-hidden">
      {/* Confetti Animation Elements */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {CONFETTI_ITEMS.map((item, idx) => (
          <div
            key={idx}
            className={`absolute top-0 animate-confetti ${item.color} ${item.shape} ${item.size}`}
            style={{
              left: item.left,
              animationDelay: item.delay,
              animationDuration: item.duration,
            }}
          />
        ))}
      </div>

      <span className="relative z-10">गेटपास बनाये अब हिंदी मे भी !</span>
      <button
        onClick={handleDismiss}
        className="absolute right-4 text-white/70 hover:text-white transition-colors p-1 flex items-center justify-center rounded-full hover:bg-white/10 w-6 h-6 z-10"
        aria-label="Close"
      >
        <i className="fa fa-times text-sm"></i>
      </button>
    </div>
  );
};

export default PromoBanner;
